import { Fragment, type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { twoSectionTopWidgetHomeV2Queue$key } from "scmp-app/queries/__generated__/twoSectionTopWidgetHomeV2Queue.graphql";

import {
  ColumnDivider,
  Container,
  ItemDivider,
  ListColumn,
  StyledLead,
  StyledListItem,
} from "./styles";

type Props = ContentItemRenderVariantProps & {
  reference: twoSectionTopWidgetHomeV2Queue$key;
};

export const HomeV2SectionTopWidgetTwo: FunctionComponent<Props> = ({
  className,
  onClick,
  reference,
}) => {
  const data = useFragment(
    graphql`
      fragment twoSectionTopWidgetHomeV2Queue on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Content {
            entityId
            ...homeSecondaryV2ContentItemContent
            ...leadSectionTopHomeV2Content
          }
        }
      }
    `,
    reference,
  );

  const items = (data ?? []).map(({ node }) => node).filter(node => notEmpty(node.entityId));

  if (items.length === 0) return null;

  const [leading, ...rest] = items;
  const listItems = rest.slice(0, 4);

  return (
    <Container className={className}>
      <StyledLead onClick={onClick} reference={leading} />

      {listItems.length > 0 && (
        <>
          <ColumnDivider />
          <ListColumn>
            {listItems.map((node, index) => (
              <Fragment key={node.entityId}>
                {index > 0 && <ItemDivider />}
                <StyledListItem
                  isReadingTimeEnabled
                  onClick={onClick}
                  reference={node}
                  withComment
                  withLiveTag
                />
              </Fragment>
            ))}
          </ListColumn>
        </>
      )}
    </Container>
  );
};

HomeV2SectionTopWidgetTwo.displayName = "HomeV2SectionTopWidgetTwo";
